/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, VFlow } from 'bold-ui'
import { isUndefinedOrNull } from 'util/checks'
import {
  HistoricoSectionStyles,
  MEDICOES_ANTROPOMETRIA,
  MEDICOES_SINAIS_VITAIS,
} from 'view/atendimentos/detail/historico/model/model-historico'
import { HistoricoMedicaoModel } from 'view/atendimentos/types/model-historicoMedicao'

import { convertMedicaoModelToMedicoesModel } from '../../../../utils/utils-historico-medicoes'
import { HistoricoSectionType } from '../../../HistoricoSection'
import HistoricoMedicoesAntropometria from './HistoricoMedicoesAntropometria'
import HistoricoMedicoesSinaisVitais from './HistoricoMedicoesSinaisVitais'

interface HistoricoMedicoesPanelProps {
  sectionStyle: HistoricoSectionType
  medicoes: HistoricoMedicaoModel[]
  isAtendimentoObservacao?: boolean
}

export default function HistoricoMedicoesPanel(props: Readonly<HistoricoMedicoesPanelProps>) {
  const { sectionStyle, medicoes, isAtendimentoObservacao = false } = props

  const styles = createStyles(HistoricoSectionStyles[sectionStyle].color)

  const medicoesModel = convertMedicaoModelToMedicoesModel(medicoes)

  const sinaisVitais = medicoesModel.map((medicao) => medicao.sinaisVitais)
  const antropometria = medicoesModel.map((medicao) => medicao.antropometria)

  const hasAntropometria = medicoes.some((it) => hasAnyValueAntropometria(it))
  const hasSinaisVitais = medicoes.some((it) => hasAnyValueSinaisVitais(it))

  if (!hasAntropometria && !hasSinaisVitais) {
    return null
  }

  return (
    <VFlow>
      <Heading style={styles.color} level={5}>
        Medições
      </Heading>

      {hasSinaisVitais && (
        <HistoricoMedicoesSinaisVitais sinaisVitais={sinaisVitais} isAtendimentoObservacao={isAtendimentoObservacao} />
      )}

      {hasAntropometria && (
        <HistoricoMedicoesAntropometria
          antropometria={antropometria}
          isAtendimentoObservacao={isAtendimentoObservacao}
        />
      )}
    </VFlow>
  )
}

const hasAnyValueAntropometria = (antropometria: HistoricoMedicaoModel): boolean =>
  MEDICOES_ANTROPOMETRIA.some((campo) => !isUndefinedOrNull(antropometria[campo]))

const hasAnyValueSinaisVitais = (sinaisVitais: HistoricoMedicaoModel): boolean =>
  MEDICOES_SINAIS_VITAIS.some((campo) => !isUndefinedOrNull(sinaisVitais[campo]))

const createStyles = (cor: string) => ({
  color: css`
    color: ${cor};
  `,
})
